const WEBGL_VIEW_PATH_REGEX = /^\/([A-Za-z0-9]{8})\/webgl_view\/?$/;

function checkIfInIframe() {
  try {
    return window.location !== window.parent.location;
  } catch (error) {
    return true;
  }
}

function getEmbeddedWebglContext() {
  const searchParams = new URLSearchParams(window.location.search);
  const sessionIdFromQuery = searchParams.get('sessid') || '';
  const hasChannel = !!searchParams.get('channel');
  const isWebglViewPath = WEBGL_VIEW_PATH_REGEX.test(window.location.pathname);
  const isInIframe = checkIfInIframe();

  return {
    hasChannel,
    isInIframe,
    isWebglViewPath,
    sessionIdFromQuery,
    isEmbeddedWebglView: isInIframe && isWebglViewPath && hasChannel,
  };
}

module.exports = {
  WEBGL_VIEW_PATH_REGEX,
  checkIfInIframe,
  getEmbeddedWebglContext,
};
